import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CommonMethods } from '../../common-methods';

@Injectable({
	providedIn: 'root'
})
export class RoleGuard implements CanActivate {
	constructor(private router: Router) { }

	/**
	* Check the roles matched or not
	* if role matched then ckeck the permissions of role
	* If role not matched then navigate to 'access-denied page
	*/
	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

		const path = route.data['path'];
		//Get the current role from localStorage
		const currentRole = CommonMethods.getItem("role");

		// Check the role matching or not 
		let ingressFilteredArray = CommonMethods.ingressSettings.filter((x: any) => x.role == currentRole);

		let returnValue: boolean = false;

		//Check the roles matched or not
		if (ingressFilteredArray.length > 0) {
			let permissions = ingressFilteredArray[0].permission;
			//Ckeck the permissions of role
			if (path && !permissions.includes(path)) {
				this.router.navigateByUrl('access-denied');
				returnValue = false;
			} else {
				returnValue = true;
			}
		} else {
			this.router.navigateByUrl('access-denied');
			returnValue = false;
		}
		return returnValue;
	}

}